import { useEffect } from 'react';
import { SignIn, useAuth } from '@clerk/react';
import { Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import useTenant from '../../hooks/useTenant';
import AuthLayout from '../../layouts/Auth';
import useClerkAppearance from './useClerkAppearance';

function ClerkSignIn() {
  const { branding, selectedSlug } = useTenant();
  const location = useLocation();
  const navigate = useNavigate();
  const { isSignedIn, isLoaded } = useAuth();
  const appearance = useClerkAppearance();
  const redirectTo = location.state?.from || '/dashboard';
  // Só monta o <SignIn> com o branding do tenant já resolvido — senão a
  // aparência troca no meio do preenchimento.
  const brandingPronto = !selectedSlug || branding !== null;
  const pronto = isLoaded && brandingPronto;

  useEffect(() => {
    if (isSignedIn) {
      navigate(redirectTo, { replace: true });
    }
  }, [isSignedIn, redirectTo, navigate]);

  return (
    <AuthLayout>
      <Box sx={{ minHeight: 420, opacity: pronto ? 1 : 0, transition: 'opacity 0.3s ease' }}>
        {pronto && (
          <SignIn
            routing="virtual"
            signUpUrl="/registre-se"
            fallbackRedirectUrl={redirectTo}
            forceRedirectUrl={redirectTo}
            appearance={appearance}
          />
        )}
      </Box>
    </AuthLayout>
  );
}

export default ClerkSignIn;
